import { TStates } from '@Managers/StateMachine/StateMachine.types';
import { EGameStates } from './GameStates';
import {
    completeGambleStateResolver,
    completeGameStartResolver,
    completeIdleStateResolver,
    completeSpinStateResolver,
    completeWinStateResolver,
    postWinStepStateResolver,
    resultGambleStateResolver
} from './StateResolvers';

export const StatesDefault: TStates<EGameStates> = {
    [EGameStates.GAME_START]: {
        resolver: completeGameStartResolver
    },
    [EGameStates.IDLE_STATE]: {
        resolver: completeIdleStateResolver
    },
    [EGameStates.PRE_SPIN_STATE]: {},
    [EGameStates.SPIN_STATE]: {},
    [EGameStates.POST_SPIN_STATE]: {},
    [EGameStates.COMPLETE_SPIN_STATE]: {
        resolver: completeSpinStateResolver
    },
    [EGameStates.PRE_WIN_STATE]: {},
    [EGameStates.PRE_WIN_STEP_STATE]: {},
    [EGameStates.PRE_WIN_FEATURES_STATE]: {},
    [EGameStates.WIN_STATE]: {},
    [EGameStates.POST_WIN_STEP_STATE]: {
        resolver: postWinStepStateResolver
    },
    [EGameStates.POST_WIN_STATE]: {},
    [EGameStates.POST_WIN_FEATURES_STATE]: {},
    [EGameStates.COMPLETE_WIN_STATE]: {
        resolver: completeWinStateResolver
    },
    [EGameStates.PRE_GAMBLE_STATE]: {},
    [EGameStates.GAMBLE_STATE]: {},
    [EGameStates.GAMBLE_RESULT_STATE]: {
        resolver: resultGambleStateResolver
    },
    [EGameStates.POST_GAMBLE_STATE]: {},
    [EGameStates.COMPLETE_GAMBLE_STATE]: {
        resolver: completeGambleStateResolver
    }
};
